module.exports = __webpack_public_path__ + "static/img/9.b0849ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/11/zh/9.png
// module id = lkS/
// module chunks = 0